export function mapAddressSuggestionToAddress(suggestion: AddressSuggestion): AddressSearch {
  const id = Number(suggestion.Id);

  return {
    Id: Number.isNaN(id) ? undefined : id,
    StreetName: suggestion.StreetName,
    StreetNumber: suggestion.HouseNumber,
    Zip: suggestion.ZipCode,
    City: suggestion.City,
    Country: suggestion.CountryName,
    CountryCode: suggestion.CountryCode,
    Unit: [suggestion.Floor, suggestion.Door].filter(Boolean).join('. ')
  };
}
